import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.chat');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";
@Component({
    selector: 'wiz-layout-chat',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.chat/view.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  min-height: 0;
}`],
})
export class LayoutChatComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) {}
    public async ngOnInit() { await this.service.init(); await this.service.render(); }
}

export default LayoutChatComponent;